import React, { useContext, useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Header, Container, Grid, Transition} from 'semantic-ui-react';
import Emoji from '../components/Emoji'
import PostForm from '../components/PostForm'
import CaptureCamera from '../components/CaptureCamera'
import { AuthContext } from '../context/auth';
import { FETCH_POSTS_QUERY } from '../util/graphql';
import FloatingActionButton from '../components/FloatingActionButton/FloatingActionButton';

function CreatePost() {
  const { user } = useContext(AuthContext);
  // const { postPicture } = useContext(PostContext);
  const [postPicture, setPostPicture] = useState('')
  const {
    data: { getPosts: posts }
  } = useQuery(FETCH_POSTS_QUERY);
  
  const [visible, setVisibility] = useState(false);
  
  useEffect(() => {
    setVisibility(visible); // update the state
  }, [visible]); // hook is only triggered when value changes

  const handleTransition = () => {
    if (postPicture) {
      setVisibility(true);
    }
    return;
  }

  const returnHomeButton = user ? (
    <FloatingActionButton icon="backward" text="Click to go back" to="/" color="red" />
    
  ) : (
    <FloatingActionButton icon="backward" text="Click to go back" to="/login" color="red" />
      
  );


  return (
    <>

<Container>
      <Header textAlign="center" as='h1'> Post Your Free Food With Others!</Header>
      
      <Header textAlign="center" as='h1'> First, Take a Picture <Emoji symbol="📷" /></Header>
      <CaptureCamera onImageUpload={setPostPicture} handleTransition={handleTransition} postPicture={postPicture} />
      {returnHomeButton}
      <Transition.Group animation="drop" duration="500">
            {visible && (
              <>
              <Header textAlign="center" as='h1'> Second, Add Some Description <Emoji symbol="✍️" /></Header>
              <Header textAlign="center" as='h4'>This is a great place to add address, description and type of food at the event. Enter details about your post</Header>
              <Grid columns={1}>
              <Grid.Row className="page-title">
                <PostForm postPicture={postPicture}/>
              </Grid.Row>
            </Grid>
            </>
            )}
          </Transition.Group>

      
      
   </Container>  



  


    </>
  );
}

export default CreatePost;
